import { Season } from 'app/frontend/types/custom'
import { uniqBy } from 'lodash'
import { getSeasonData, SeasonEntry } from './seasonData'

export function getDungeons(
  gameVersion: wowaudit.PageInfo['gameVersion'],
): Season['keystone_dungeons'] {
  return uniqBy(
    getSeasonData(gameVersion)
      .filter(
        (
          season,
        ): season is SeasonEntry & {
          metadata: NonNullable<SeasonEntry['metadata']>
        } => !!season.metadata,
      )
      .flatMap(
        (season) => season.metadata.keystone_dungeons,
      ) as Season['keystone_dungeons'],
    'id',
  )
}
